import * as React from "react";
import { forwardRef } from "react";
const SvgErrorIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: 148,
	height: 148,
	viewBox: "0 0 148 148",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M74 143.067C112.144 143.067 143.067 112.144 143.067 74C143.067 35.8555 112.144 4.93335 74 4.93335C35.8555 4.93335 4.93335 35.8555 4.93335 74C4.93335 112.144 35.8555 143.067 74 143.067Z",
	stroke: "#F5222D",
	strokeWidth: 6,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M46.3728 101.629L101.626 46.3752",
	stroke: "#F5222D",
	strokeWidth: 6,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M101.626 101.629L46.3728 46.3752",
	stroke: "#F5222D",
	strokeWidth: 6,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgErrorIcon);
export default ForwardRef;
